import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditAltPassword = mutatorAction('updateEditAltPassword', function (password) {
    var store = connectedAccountsStore();
    store.editAccountState.altPassword = password;
});
//# sourceMappingURL=updateEditAltPassword.js.map